var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAllSolnRecordsBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_247_2",
    "data-name": "Component 247 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7707",
    "data-name": "Rectangle 7707",
    width: 24,
    height: 24,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15229",
    "data-name": "Group 15229",
    transform: "translate(-79.028 -168.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15220",
    "data-name": "Group 15220",
    transform: "translate(84.028 173.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15219",
    "data-name": "Group 15219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15216",
    "data-name": "Group 15216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15213",
    "data-name": "Group 15213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15217",
    "data-name": "Group 15217"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6532",
    "data-name": "Rectangle 6532",
    width: 5.311,
    height: 5.311,
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6533",
    "data-name": "Rectangle 6533",
    width: 5.311,
    height: 5.311,
    transform: "translate(8.938 8.938)",
    fill: "none",
    stroke: "#707070",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_824",
    "data-name": "Line 824",
    x2: 3.627,
    y2: 3.627,
    transform: "translate(5.311 5.311)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15215",
    "data-name": "Group 15215",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15218",
    "data-name": "Group 15218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14645",
    "data-name": "Path 14645",
    d: "M27.821,6.263V.5H22.057",
    transform: "translate(-13.454 -0.5)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14646",
    "data-name": "Path 14646",
    d: "M.5,21.5v5.985H6.485",
    transform: "translate(-0.5 -13.122)",
    fill: "none",
    stroke: "#707070",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSolnRecordsBlue);
export default __webpack_public_path__ + "static/media/AllSolnRecordsBlue.c192d1b26c34d0ec8716c38cc3c51681.svg";
export { ForwardRef as ReactComponent };